"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../WithErrorHandler");
var smartScroll_1 = __importDefault(require("../../utils/smartScroll"));
var tools_1 = require("../../utils/tools");
var smartScrollObj = {};
var Index = function (props) {
    var visible = react_1.useMemo(function () { return props.visible; }, [props.visible]);
    var direction = react_1.useMemo(function () { return props.direction || "toUp" /* 向上 */; }, [props.direction]);
    var autoScrollId = react_1.useMemo(function () { return props.autoScrollId || ''; }, [props.autoScrollId]);
    var needAnimation = react_1.useMemo(function () {
        return typeof props.needAnimation === 'boolean' ? props.needAnimation : 'true';
    }, [props.needAnimation]);
    var cn = react_1.useMemo(function () { return props.cn; }, [props.cn]);
    var _a = __read(react_1.useState(function () { return "modal_" + tools_1.getRandom(); }), 2), domID = _a[0], setDomID = _a[1];
    var _b = __read(react_1.useState('hide'), 2), popAnimationCN = _b[0], setPopAnimationCN = _b[1];
    react_1.useEffect(function () {
        // 初始化smartScroll
        if (domID && typeof window !== 'undefined') {
            var scrollId = typeof autoScrollId !== 'undefined'
                ? typeof autoScrollId === 'string' && autoScrollId
                    ? [domID + "_con", autoScrollId]
                    : // @ts-ignore
                     __spreadArray([domID + "_con"], __read(autoScrollId))
                : domID + "_con";
            smartScrollObj.modalPopNew = new smartScroll_1.default("#" + domID, scrollId);
        }
    }, [domID, autoScrollId]);
    react_1.useEffect(function () {
        if (visible && typeof window !== 'undefined') {
            // 允许滚动
            smartScrollObj.modalPopNew.preventScroll();
        }
        else {
            smartScrollObj.modalPopNew.allowScroll();
        }
    }, [visible]);
    react_1.useEffect(function () {
        var str;
        if (visible) {
            str = needAnimation
                ? "xinche-modal_" + (direction === "toUp" /* 向上 */
                    ? 'toTop_show'
                    : direction === "toDown" /* 向下 */
                        ? 'toBot_show'
                        : 'center_show')
                : 'modal_show';
        }
        else if (popAnimationCN != 'hide') {
            if (needAnimation) {
                setTimeout(function () {
                    setPopAnimationCN('hide');
                }, 300);
                str = "xinche-modal_" + (direction === "toUp" /* 向上 */
                    ? 'toTop_hide'
                    : direction === "toDown" /* 向下 */
                        ? 'toBot_hide'
                        : 'center_hide');
            }
            else {
                setPopAnimationCN('hide');
            }
        }
        str && setPopAnimationCN(str);
    }, [visible, popAnimationCN]);
    var onClickMask = react_1.useCallback(function () {
        if (typeof props.allowMaskCloseFn !== 'undefined') {
            props.allowMaskCloseFn();
        }
    }, []);
    if (typeof window !== 'undefined') {
        return (react_1.default.createElement("div", { className: "xinche-modal " + (direction === "toUp" /* 向上 */
                ? 'toTop'
                : direction === "toDown" /* 向下 */
                    ? 'toBot'
                    : 'center') + " " + (cn || '') + " " + popAnimationCN, onClick: onClickMask, id: domID },
            react_1.default.createElement("div", { className: "xinche-modal-con " + (props.contentCn || ''), id: domID + "_con", onClick: function (e) {
                    e.stopPropagation();
                } }, props.children),
            react_1.default.createElement("div", { onClick: function (e) {
                    e.stopPropagation();
                } }, props.otherDom && props.otherDom)));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
